/**
 * Created by Juno Peng on 1/5/2024.
 * Description:
 * Edit/Delete Button
 * ------ maintenance history ------
 */

import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { SlideSheetService } from '../../../../services/slide-sheet.service';
import { SlideSheetActionTypes } from '../../../slide-sheet/slide-sheet.model';
import { AlertWindowService } from '../../../../widgets/alert-window/alert-window.service';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';
import { AdminPortfolioUploadService, PortfolioUploadType } from './admin-portfolio-upload.service';
import { PortfolioService } from '../../../../tamalelibs/services/portfolio.service';

@Component({
    selector: 'tam-admin-portfolio-upload-action-button',
    template: `<div class="button-group"><div kendoTooltip position="bottom" tid="Edit" (click)='editClicked($event)' class='button-group-icon-edit' title="Edit"><smart-icon name='pencil' class='smart-icon light'></smart-icon></div><div kendoTooltip position="bottom" tid="Delete" (click)='deleteClicked($event)' class='button-group-icon-delete' title="Delete"><smart-icon name='trash' class='smart-icon light'></smart-icon></div></div>`
})
export class AdminPortfolioUploadButtonComponent implements ICellRendererAngularComp {
    params: any;

    constructor(
        private _alertWindow: AlertWindowService,
        private _adminPortfolioUploadService: AdminPortfolioUploadService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _portfolioService: PortfolioService,
        private _toast: ToastService,
        private _slideSheetService: SlideSheetService,
    ) { }

    agInit(params: any): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

    // Delete Button
    deleteClicked(cell: any): void {
        const portfolioData = Object.assign({}, this.params.data);
        this._changeDetectorRef.detectChanges();

        const message = `Are you sure you want to delete ${portfolioData.configName}?`;
        const subscription = this._alertWindow.warn(StringLiteralsPipe.translate('general.delete_confirmation_required'),
            [message], StringLiteralsPipe.translate('general.delete'), StringLiteralsPipe.translate('general.cancel'))
            .subscribe((result: boolean) => {
                if (result) {
                    this._portfolioService.deletePortfolio(portfolioData.configID).pipe(
                        catchError(error => {
                            this._toast.notify({
                                message: error,
                                style: NotificationStyles.Error
                            });
                            return of(error);
                        })
                    ).subscribe(() => {
                        this._toast.notify({
                            message: portfolioData.configName + ' is deleted successfully.',
                            style: NotificationStyles.Success
                        });

                        this._adminPortfolioUploadService.subject$.next({
                            type: PortfolioUploadType.DELETE_PORTFOLIO_UPLOAD,
                            payload: portfolioData
                        });
                    });
                }
                subscription.unsubscribe();
            });
    }

    // Edit Button
    editClicked(cell: any): void {
        const portfolioData = this.params.data;
        if (portfolioData) {
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.ADMIN_CONSOLE_PORTFOLIO_UPLOAD_EDITOR,
                payload: portfolioData
            });
        }
    }
}
